import { render, staticRenderFns } from "./AI_assistant.vue?vue&type=template&id=2aaf9ddb&scoped=true&"
import script from "./AI_assistant.vue?vue&type=script&lang=js&"
export * from "./AI_assistant.vue?vue&type=script&lang=js&"
import style0 from "./AI_assistant.vue?vue&type=style&index=0&id=2aaf9ddb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aaf9ddb",
  null
  
)

export default component.exports